// extracted by mini-css-extract-plugin
export var button = "_n-0";
export var buttonContent = "_n-e";
export var buttonGroup = "_n-c";
export var dontRestrainIconWidth = "_n-a";
export var dropdownButton = "_n-b";
export var iconContainer = "_n-9";
export var lg = "_n-4";
export var md = "_n-3";
export var pending = "_n-f";
export var sm = "_n-2";
export var spinner = "_n-d";
export var squared = "_n-8";
export var wrapText = "_n-g";
export var xl = "_n-5";
export var xs = "_n-1";
export var xxl = "_n-6";
export var xxxl = "_n-7";